module.exports = __webpack_public_path__ + "static/img/children8.9823ae59.jpg";